module.exports = __webpack_public_path__ + "img/ConsumptionService.6de6f771.png";